import { render } from "./App.vue?vue&type=template&id=190518fc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=190518fc&lang=css"

import exportComponent from "/Users/danilomeulens/Projects/_sandbox/simpsonbay_geneology/source/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__